import React from 'react';
import {styled, withTheme} from "@material-ui/core/styles";


function TextElement({ text, bold, type, theme = '', center, uppercase, element = 'p', onClick, aditionalClass = '' }){
    let className = '';

    switch (type) {
        case 'cta-medium':
            className = 'cta-medium';
            break;
        case 'cta-small':
            className = 'cta-small';
            break;
        case 'label-1':
            className = 'label-1';
            break;
        case 'label-2':
            className = 'label-2';
            break;
        case 'body-1':
            className = 'body-1';
            break;
        case 'body-2':
            className = 'body-2';
            break;
        case 'label-small':
            className = 'label-small';
            break;
        case 'caption':
            className = 'caption';
            break;
        case 'breadcrumb':
            className = 'breadcrumb';
            break;
        default:
            className = 'label-small';
    }

    if (bold) {
        className = className + ' bold';
    }

    if (center) {
        className = className + ' center';
    }

    if (uppercase) {
        className = className + ' uppercase';
    }

    className += ' ' + type;
    className += ' ' + theme;
    className += ' ' + aditionalClass;

    return (
        <ContainerElement>
            {(text && element === "p") &&
                <>
                    {(typeof text === 'string' || text instanceof String) &&
                        <>
                            {text.split("\n").map(function (item, i) {
                                return (
                                    <TextElementP key={i} className={className}>
                                        {item}
                                    </TextElementP>
                                )
                            })}
                        </>
                    }

                    {!(typeof text === 'string' || text instanceof String) &&
                        <TextElementP className={className}>
                            {text}
                        </TextElementP>
                    }
                </>
            }

            {(element === 'span') &&
                <TextElementSpan className={className} onClick={onClick}>
                    {text}
                </TextElementSpan>
            }
        </ContainerElement>
    );
}


const ContainerElement = styled(withTheme('div'))(({theme}) => {
    return {
        display: 'contents'
    }
})


const TextElementP = styled(withTheme('p'))(({theme}) => {
    return {
        '&.label-1': {
            color: theme?.typography?.root?.color ?? 'black',
            'font-weight': 'normal',
            'font-size': '14px',
            'line-height': '16px',
            'letter-spacing': '1px',
            'margin-block-start': '0',
        },

        '&.body-1': {
            color: theme?.typography?.root?.color ?? 'black',
            'font-weight': 'normal',
            'font-size': '16px',
            'line-height': '22px',
            'letter-spacing': '0px',
            'margin-block-end': '0',
            'margin-block-start': '0',
        },

        '&.body-2': {
            color: theme?.typography?.root?.color ?? 'black',
            'font-weight': 'normal',
            'font-size': '14px',
            'line-height': '24px',
            'letter-spacing': '0px',
            'margin-block-end': '0',
            'margin-block-start': '0',
        },

        '&.caption': {
            color: theme?.typography?.root?.color ?? 'black',
            'font-style': 'normal',
            'font-weight': '500',
            'font-size': '12px',
            'line-height': '24px',
            'letter-spacing': '0.25px',
            'margin-block-end': '0',
            'margin-block-start': '0',
        },

        '&.bold': {
            'font-weight': 'bold',
        },

        '&.uppercase': {
            'text-transform': 'uppercase',
        },

        '&.center': {
            'text-align': 'center',
        }
    }
})



const TextElementSpan = styled(withTheme('span'))(({theme}) => {
    return {
        '&.label-1': {
            color: theme?.typography?.root.color ?? 'black',
            'font-weight': 'normal',
            'font-size': '14px',
            'line-height': '16px',
            'letter-spacing': '1px',
            'margin-block-start': '0',
        },

        '&.body-1': {
            color: theme?.typography?.root?.color ?? 'black',
            'font-weight': 'normal',
            'font-size': '14px',
            'line-height': '20px',
            'letter-spacing': '0px',
            'margin-block-start': '0',
        },

        '&.caption': {
            color: theme?.typography.root?.color ?? 'black',
            'font-style': 'normal',
            'font-weight': '500',
            'font-size': '12px',
            'line-height': '20px',
            'letter-spacing': '0.25px',
            'margin-block-end': '0',
        },

        '&.bold': {
            'font-weight': 'bold',
        },

        '&.uppercase': {
            'text-transform': 'uppercase',
        },

        '&.center': {
            'text-align': 'center',
        }
    }
})


export default TextElement;
